module.exports = __webpack_public_path__ + "static/media/coins.240fb682.svg";